import { Images } from "@/utils/imageRelativePaths";
import { Astro_Strings } from "./Strings";
import {
  AstroCardDataType,
  AstroLiveCardDataType,
  CategoryData,
  colorCardType,
  FormInitialDataType,
  KundliCardsDataType,
  MiniCardDetailsType,
  SubCategoryData,
  genderType,
  kundliDataType,
  manglikDataType,
  timingsDataType,
  zodiacDataType,
  ZodiacTypes,
  TabOption,
  TableDataType,
  LogoNavBarDataType,
} from "./Enum";
import { FormResponse } from "./helpers/CreatorForm.types";
import { RowItem } from "@/types/common.types";

export const ZODIAC_SIGNS: zodiacDataType[] = [
  {
    logo: Images.leo,
    name: "Leo",
    value: ZodiacTypes.LEO,
  },
  {
    logo: Images.taurus,
    name: "Taurus",
    value: ZodiacTypes.TAURUS,
  },
  {
    logo: Images.aquarius,
    name: "Aquarius",
    value: ZodiacTypes.AQUARIUS,
  },
  {
    logo: Images.aries,
    name: "Aries",
    value: ZodiacTypes.ARIES,
  },
  {
    logo: Images.cancer,
    name: "Cancer",
    value: ZodiacTypes.CANCER,
  },
  {
    logo: Images.libra,
    name: "Libra",
    value: ZodiacTypes.LIBRA,
  },
  {
    logo: Images.scorpio,
    name: "Scorpio",
    value: ZodiacTypes.SCORPIO,
  },
  {
    logo: Images.sagittarius,
    name: "Sagittarius",
    value: ZodiacTypes.SAGITTARIUS,
  },
  {
    logo: Images.capricorn,
    name: "Capricorn",
    value: ZodiacTypes.CAPRICORN,
  },
  {
    logo: Images.pisces,
    name: "Pisces",
    value: ZodiacTypes.PISCES,
  },
  {
    logo: Images.gemini,
    name: "Gemini",
    value: ZodiacTypes.GEMINI,
  },
  {
    logo: Images.virgo,
    name: "Virgo",
    value: ZodiacTypes.VIRGO,
  },
];

export const dayList = [
  Astro_Strings.YESTERDAY,
  Astro_Strings.TODAY,
  Astro_Strings.TOMORROW,
];
export const ZODIAC_SIGNS_DETAILS: colorCardType[] = [
  {
    icon: Images.hearts_two,
    title: "Personal",
    key:'personal_life',
    description:
      "Lorem Ipsum is dummy text to represent the dummy content. Lorem Ipsum is dummy text to represent the dummy content. ",
  },
  {
    icon: Images.education,
    title: "Career",
    key:'profession',
    description:
      "Lorem Ipsum is dummy text to represent the dummy content. Lorem Ipsum is dummy text to represent the dummy content. ",
  },
  {
    icon: Images.health,
    title: "Health",
    key:'health',
    description:
      "Lorem Ipsum is dummy text to represent the dummy content. Lorem Ipsum is dummy text to represent the dummy content. ",
  },
  {
    icon: Images.plane,
    title: "Travel",
    key:'travel',
    description:
      "Lorem Ipsum is dummy text to represent the dummy content. Lorem Ipsum is dummy text to represent the dummy content. ",
  },
  {
    icon: Images.diamond,
    title: "Luck",
    key:'luck',
    description:
      "Lorem Ipsum is dummy text to represent the dummy content. Lorem Ipsum is dummy text to represent the dummy content. ",
  },
  {
    icon: Images.face_smile,
    title: "Emotion",
    key:'emotions',
    description:
      "Lorem Ipsum is dummy text to represent the dummy content. Lorem Ipsum is dummy text to represent the dummy content. ",
  },
];

export const toggleList = [
  Astro_Strings.MONTHLY_HOROSCOPE,
  Astro_Strings.YEARLY_HOROSCOPE,
];

export const MINI_CARD_DETAILS: MiniCardDetailsType[] = [
  {
    image: Images.sun,
    names: ["Sunrise", "Sunset"],
  },
  {
    image: Images.moon,
    names: ["Moonrise", "Moonset"],
  },
];

export const PANCHANG_DATA: string[] = [
  "Tithi",
  "Pratipada",
  "Yog",
  "Sadhya",
  "Karan",
  "Kaulav",
  "Nakshatra",
  "Shatabisha",
];

export const ADDITIONAL_DETAILS_DATA: string[] = [
  "text",
  "text",
  "text",
  "text",
  "text",
  "text",
];

export const AUSPICIOUS_TIMINGS_DETAILS: timingsDataType[] = [
  {
    name: "Kantaka/ Mrityu",
    initial_time: "5/12/23 02:47:05 AM",
    final_time: "5/12/23 02:47:05 PM",
  },
  {
    name: "Kantaka/ Mrityu",
    initial_time: "5/12/23 02:47:05 AM",
    final_time: "5/12/23 02:47:05 PM",
  },
  {
    name: "Kantaka/ Mrityu",
    initial_time: "5/12/23 02:47:05 AM",
    final_time: "5/12/23 02:47:05 PM",
  },
];

export const INAUSPICIOUS_TIMINGS_DETAILS: timingsDataType[] = [
  {
    name: "Kantaka/ Mrityu",
    initial_time: "5/12/23 02:47:05 AM",
    final_time: "5/12/23 02:47:05 PM",
  },
  {
    name: "Kantaka/ Mrityu",
    initial_time: "5/12/23 02:47:05 AM",
    final_time: "5/12/23 02:47:05 PM",
  },
  {
    name: "Kantaka/ Mrityu",
    initial_time: "5/12/23 02:47:05 AM",
    final_time: "5/12/23 02:47:05 PM",
  },
];

export const ASTROLOGERS_DATA: AstroCardDataType[] = [
  {
    image: Images.astroImage1,
    name: "Priyanka",
    diamonds: 20,
    id: "645c806cc963558fb2ec367e",
  },
  {
    image: Images.astroImage2,
    name: "Monalisa",
    diamonds: 20,
    id: "650a8a093bcf7c72e8e9b6f7",
  },
  {
    image: Images.astroImage2,
    name: "Christiana",
    diamonds: 20,
    id: "645c806cc963558fb2ec367e",
  },
];

export const LIVE_ASTROLOGERS_DATA: AstroLiveCardDataType[] = [
  {
    photo: Images.astroImage4,
    years_of_experience: 3,
    live: true,
    language: ["English"],
    name: "Rupali Singh",
    topic: ["Fashion"],
    image: Images.astroImage4,
    liveRoom: {
      id: 0,
      name: "",
      privacy: "",
      userId: "",
      shareableUrl: "",
      roomIcon: "",
      playUrl: "",
      membersCount: 0,
      isCreator: true,
      languages: ["", ""],
    },
    userProfile: {
      userId: "",
      userName: "",
      rate: 0,
      name: "",
      country: "",
      status: "",
      level: 0,
      photo: "",
    },
  },
  {
    photo: Images.astroImage5,
    years_of_experience: 0,
    live: false,
    language: [],
    name: "Rupali Singh",
    topic: ["Fashion", "Makeup"],
    image: Images.astroImage5,
    liveRoom: {
      id: 0,
      name: "",
      privacy: "",
      userId: "",
      shareableUrl: "",
      roomIcon: "",
      playUrl: "",
      membersCount: 0,
      isCreator: true,
      languages: ["", ""],
    },
    userProfile: {
      userId: "",
      rate: 0,
      userName: "",
      name: "",
      country: "",
      status: "",
      level: 0,
      photo: "",
    },
  },
  {
    photo: Images.astroImage5,
    years_of_experience: 0,
    live: false,
    language: [],
    name: "Rupali Singh",
    topic: ["Fashion", "Makeup"],
    image: Images.astroImage5,
    liveRoom: {
      id: 0,
      name: "",
      privacy: "",
      userId: "",
      shareableUrl: "",
      roomIcon: "",
      playUrl: "",
      membersCount: 0,
      isCreator: true,
      languages: ["", ""],
    },
    userProfile: {
      userId: "",
      rate: 0,
      userName: "",
      name: "",
      country: "",
      status: "",
      level: 0,
      photo: "",
    },
  },
];

export const KUNDLI_CENTER_DATA: KundliCardsDataType[] = [
  {
    backImage: Images.kundliImage1,
    icon: Images.IconSun,
    name: Astro_Strings.DAILY_HOROSCOPE,
    page: "daily-horoscope",
  },
  {
    backImage: Images.kundliImage2,
    icon: Images.IconPanchang,
    name: Astro_Strings.TODAYS_PANCHANG,
    page: "todays-panchang",
  },
  {
    backImage: Images.kundliImage3,
    icon: Images.IconKundli,
    name: Astro_Strings.KUNDLIS_MATCH,
    page: "kundli-match/details-form",
  },
  {
    backImage: Images.kundliImage3,
    icon: Images.IconFreeKundli,
    name: Astro_Strings.FREE_KUNDLI,
    page: "free-kundli",
  },
];

export const formInitialData: FormResponse[] = [
  {
    name: "",
    DOB: new Date(),
    time_of_birth: "",
    place_of_birth: "",
  },
  {
    name: "",
    DOB: new Date(),
    time_of_birth: "",
    place_of_birth: "",
  },
];

export const genderData: genderType = {
  male: "Male",
  female: "Female",
};

export const KUNDLI_MATCH_RESULT_DATA: colorCardType[] = [
  {
    icon: "",
    title: "Compatibility(Varna)",
    description:
      "Lorem Ipsum is dummy text to represent the dummy content. Lorem Ipsum is dummy text.",
    received_points: 0.5,
    total_points: 1,
  },
  {
    icon: "",
    title: "Love (Bhakut)",
    description:
      "Lorem Ipsum is dummy text to represent the dummy content. Lorem Ipsum is dummy text.",
    received_points: 4,
    total_points: 7,
  },
];

export const MANGLIK_DATA: manglikDataType[] = [
  {
    name: "Sanjith Dev",
    type: Astro_Strings.MANGLIK,
  },
  {
    name: "Manjula Naik",
    type: Astro_Strings.NON_MANGLIK,
  },
];

export const EXISTING_KUNDLI_DATA: kundliDataType[] = [
  {
    id: 1,
    name: "Monika",
    DOB: new Date().toString().slice(4, 13),
    time_of_birth: new Date().toString().slice(15, 21) + " PM",
    location: "Bangalore, India",
  },
  {
    id: 2,
    name: "Jay chabra",
    DOB: new Date().toString().slice(4, 13),
    time_of_birth: new Date().toString().slice(15, 21) + " PM",
    location: "Bangalore, India",
  },
  {
    id: 3,
    name: "Sanjith",
    DOB: new Date().toString().slice(4, 13),
    time_of_birth: new Date().toString().slice(15, 21) + " PM",
    location: "Bangalore, India",
  },
  {
    id: 4,
    name: "Alicia",
    DOB: new Date().toString().slice(4, 13),
    time_of_birth: new Date().toString().slice(15, 21) + " PM",
    location: "Bangalore, India",
  },
];

export const SUB_CATEGORIES: SubCategoryData[] = [
  {
    name: "All",
  },
  {
    name: "Relationship",
  },
  {
    name: "Numerology",
  },
  {
    name: "Palm Reading",
  },
];

export const CATEGORY_DATA: CategoryData[] = [
  {
    _id: "",
    name: "",
    icon: "",
    viewType: "",
    filterAllowed: false,
    title: "",
    subCategories: SUB_CATEGORIES,
  },
  {
    _id: "",
    name: "",
    icon: "",
    viewType: "",
    filterAllowed: false,
    title: "",
    subCategories: SUB_CATEGORIES,
  },
];

export const kundliNames: LogoNavBarDataType[] = [
  {
    logo: "",
    name: "Alicia",
  },
  {
    logo: "",
    name: "Sanjith",
  },
  {
    logo: "",
    name: "Jay",
  },
  {
    logo: "",
    name: "Monika",
  },
];
export const KUNDLI_SUB_CATEGORIES: SubCategoryData[] = [
  {
    name: "Basics",
  },
  {
    name: "Planets",
  },
  {
    name: "Charts",
  },
  {
    name: "KP",
  },
  {
    name: "Asktakvarga",
  },
  {
    name: "Dasha",
  },
  {
    name: "Report",
  },
];
export const tableData: TableDataType = {
  name: "Arya",
  birth_date: "01 January 1988",
  birth_time: "04:29 PM",
  latitude: 28.64,
  longitude: 77.2,
  timezone: "GMT+5.5",
  sunrise: "5:44:33 AM",
  sunset: "6:23:03 PM",
};
export const BasicsData: RowItem[] = [
  {
    data: ["name", "Arya"],
  },
  {
    data: ["Birth Date", "01 January 1988"],
  },
  {
    data: ["Birth Time", "04:29 PM"],
  },
  {
    data: ["latitude", "28.64"],
  },
  {
    data: ["longitude", "77.2"],
  },
  {
    data: ["timezone", "GMT+5.5"],
  },
  {
    data: ["sunrise", "5:44:33 AM"],
  },
  {
    data: ["sunset", "6:23:03 PM"],
  },
];
export const KPtabOptions: TabOption[] = [
  {
    label: "Planets",
    value: "Planets",
  },
  {
    label: "Cusps",
    value: "Cusps",
  },
];
export const planetsTabOptions: TabOption[] = [
  {
    label: "Sign",
    value: "Sign",
  },
  {
    label: "Nakshatra",
    value: "Nakshatra",
  },
];
export const dashaTabOptions: TabOption[] = [
  {
    label: "Vimshottari",
    value: "Vimshottari",
  },
  {
    label: "Yogini",
    value: "Yogini",
  },
];
export const chartTabOptions: TabOption[] = [
  {
    label: "North Indians",
    value: "North Indians",
  },
  {
    label: "South Indians",
    value: "South Indians",
  },
];
export const reportsTabOptions: TabOption[] = [
  {
    label: "General",
    value: "General",
  },
  { label: "12 Houses", value: "12 Houses" },
  { label: "Dosha", value: "Dosha" },
];
export const planetsTableData = [
  {
    data: ["Planet", "Nakshatra", "Naksh Lord", "House"],
  },
  {
    data: ["text", "text", "text", "text"],
  },
  {
    data: ["text", "text", "text", "text"],
  },
  {
    data: ["text", "text", "text", "text"],
  },
];
export const KPTableData = [
  {
    data: ["Planet", "Sign", "Cusp", "Sign Lord", "Star lord", "Sub lord"],
  },
  {
    data: ["text", "text", "text", "text", "text", "text"],
  },
  {
    data: ["text", "text", "text", "text", "text", "text"],
  },
  {
    data: ["text", "text", "text", "text", "text", "text"],
  },
];
export const dashaTableData = [
  {
    data: ["Planet", "Start Date", "End Date"],
  },
  {
    data: ["text", "text", "text"],
  },
  {
    data: ["text", "text", "text"],
  },
  {
    data: ["text", "text", "text"],
  },
];
export const AsktakvargaTableData = [
  {
    data: ["", "AR", "AR", "AR", "AR", "AR", "AR"],
  },
  {
    data: ["SU", "text", "text", "text", "text", "text", "text"],
  },
  {
    data: ["MO", "text", "text", "text", "text", "text", "text"],
  },
  {
    data: ["MA", "text", "text", "text", "text", "text", "text"],
  },
  {
    data: ["ME", "text", "text", "text", "text", "text", "text"],
  },
  {
    data: ["JUP", "text", "text", "text", "text", "text", "text"],
  },
  {
    data: ["VEN", "text", "text", "text", "text", "text", "text"],
  },
  {
    data: ["SAT", "text", "text", "text", "text", "text", "text"],
  },
  {
    data: ["Total", "text", "text", "text", "text", "text", "text"],
  },
];
export const chartList = [
  {
    name: "Lagna",
    chartId: "D1",
  },
  {
    name: "Navasma",
    chartId: "D9",
  },
  {
    name: "Divisional",
    chartId: "",
    subCharts: [
      {
        name: "Chalit",
        chartId: "chalit",
      },
      {
        name: "Sun",
        chartId: "SUN",
      },
      {
        name: "Moon",
        chartId: "MOON",
      },
      {
        name: "Hora",
        chartId: "D2",
      },
      {
        name: "Drekkana",
        chartId: "D3",
      },
      {
        name: "Chaturthamsa",
        chartId: "D4",
      },
      {
        name: "Saptamsa",
        chartId: "D7",
      },
      {
        name: "Dasamsa",
        chartId: "D10",
      },
      {
        name: "Dwadasamsa",
        chartId: "D12",
      },
      {
        name: "Shodasamsa",
        chartId: "D16",
      },
      {
        name: "Vimsamsa",
        chartId: "D20",
      },
      {
        name: "Chaturvimsamsa",
        chartId: "D24",
      },
      {
        name: "Bhamsha",
        chartId: "D27",
      },
      {
        name: "Trimsamsa",
        chartId: "D30",
      },
      {
        name: "Khavedamsa",
        chartId: "D40",
      },
      {
        name: "Akshavedamsa",
        chartId: "D45",
      },
      {
        name: "Shastiamsa",
        chartId: "D60",
      },
    ],
  },
];

export const reportCardsdata: colorCardType[] = [
  {
    icon: Images.alien,
    title: "Character",
    description:
      "Lorem Ipsum is dummy text to represent the dummy content. Lorem Ipsum is dummy text to represent the dummy content. ",
  },
  {
    icon: Images.dumbell,
    title: "Physical",
    description:
      "Lorem Ipsum is dummy text to represent the dummy content. Lorem Ipsum is dummy text to represent the dummy content. ",
  },
  {
    icon: Images.briefcase,
    title: "Education",
    description:
      "Lorem Ipsum is dummy text to represent the dummy content. Lorem Ipsum is dummy text to represent the dummy content. ",
  },
  {
    icon: Images.hearts_two,
    title: "Family",
    description:
      "Lorem Ipsum is dummy text to represent the dummy content. Lorem Ipsum is dummy text to represent the dummy content. ",
  },
  {
    icon: Images.heart_wave,
    title: "Health",
    description:
      "Lorem Ipsum is dummy text to represent the dummy content. Lorem Ipsum is dummy text to represent the dummy content. ",
  },
];
export const housesCardData: colorCardType[] = [
  {
    title: "Self",
    description:
      "Aquarius is the sign present in the first house of your nata chart. Your window to the world reveals you to be an original, innovative, and somewhat unpredictable individual that enjoys the odd and unusual, the old and the futuristic. You tend to be idealistic and often hold utopian ideas; this can lead you to take on causes that protect individual freedoms, privacy, and the pursuit of happiness. You can count on many varied people to be good friends and companions, and assist in your endeavors whether for business or recreation. Your interests range from such subjects as antiquities and ancient beliefs, to modern science, new inventions, electronics, and computer technology. There is little that can be hidden or with-held from you because of your inquiring mind and innate sense of intuition.",
  },
  {
    title: "Income & Possessions",
    description:
      "Pisces is the sign present in the second house of your natal chart. Matters dealing with the financial side of your life can bring opportunities from a variety of sources, and many of these sources could spring from unknown origins. The success or failure of your financial endeavors would hinge mainly on your own ability to recognize the inherent risks associated with these endeavors. One such risk might occur in not being able to obtain full disclosure about an impending transaction, or not being made aware of all the ramifications once a deal is closed. There could be hidden conditions that if known might cause you to change your mind. It need not be all this mysterious if you avoid rushing into situations before fully checking them out. You are inclined to possess a natural psychic sense that gives you the ability to see through any deception or false front",
  },
];

export const HouseCharacters = [
  "Self",
  "Income & Possessions",
  "Communication",
  "Home life",
  "Pleasure",
  "Wellness & Daily routine",
  "Partnership",
  "Mysteries & Transformations",
  "Adventure & higher learning",
  "Career",
  "Networking & Prosperity",
  "Spirituality & the unconscious",
];
